module.exports = __webpack_public_path__ + "img/arrow_right_circle.62cf1a74.svg";